import { Component } from "react";
import { AlertOctagon, RefreshCw } from "lucide-react";

export default class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // Keep the dashboard usable while exposing the failing panel to the operator.
    console.error("dashboard panel failed", error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="panel-error" role="alert">
        <AlertOctagon size={17} />
        <div>
          <strong>Panel unavailable</strong>
          <p>This module failed without affecting the trading engine.</p>
          <button className="ghost-button" onClick={() => this.setState({ hasError: false })}>
            <RefreshCw size={13} /> Retry panel
          </button>
        </div>
      </div>
    );
  }
}
